define('OutSystems/ClientRuntime/ScriptsManager',["require", "exports", "./Logger"], function (require, exports, Logger) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.scheduleCustomJsLoading = exports.addScript = void 0;
    var SCRIPT_FINISHED_ATTR = "data-os-finished";
    var SCRIPTS_MANAGER_MODULE_NAME = "ScriptsManager";
    var managedScripts = new Map();
    var initialized = false;
    var lastAddedScript = null;
    function addScript(scriptURL) {
        trace("Adding script", scriptURL);
        initialize();
        var scriptInfo = managedScripts.get(scriptURL);
        if (scriptInfo) {
            trace("Script already added", scriptURL);
            return scriptInfo.promise;
        }
        var scriptElement = document.createElement("script");
        scriptElement.async = false;
        scriptElement.setAttribute("src", scriptURL);
        scriptElement.setAttribute(SCRIPT_FINISHED_ATTR, "false");
        var loadScriptPromise = new Promise(function (resolve, reject) {
            var onFinish = function () {
                scriptElement.setAttribute(SCRIPT_FINISHED_ATTR, "true");
            };
            scriptElement.onerror = scriptElement.onabort = function (e) {
                onFinish();
                reject("Error adding script '" + scriptURL + "' to document '" + document.baseURI + "'");
            };
            scriptElement.onload = function (e) {
                trace("Script added", scriptURL);
                onFinish();
                resolve(e);
            };
        });
        if (lastAddedScript) {
            lastAddedScript.domElement.parentNode.insertBefore(scriptElement, lastAddedScript.domElement.nextSibling);
        }
        else {
            document.head.appendChild(scriptElement);
        }
        managedScripts.set(scriptURL, {
            promise: loadScriptPromise,
            domElement: scriptElement,
        });
        lastAddedScript = managedScripts.get(scriptURL);
        return loadScriptPromise;
    }
    exports.addScript = addScript;
    function trace(message, script) {
        Logger.trace(SCRIPTS_MANAGER_MODULE_NAME, message + " '" + script + "' : document '" + document.baseURI + "'");
    }
    function initialize() {
        if (initialized) {
            return;
        }
        initialized = true;
        Object.defineProperty(define, "amd", {
            get: hideRequireDependingOnCaller.bind(this, define.amd),
            configurable: true,
        });
    }
    function hideRequireDependingOnCaller(amd) {
        var thisScript = document.currentScript;
        if (thisScript && thisScript.hasAttribute(SCRIPT_FINISHED_ATTR)) {
            return undefined;
        }
        return amd;
    }
    function scheduleCustomJsLoading(urls, onErrorLoadingScript) {
        return Promise.all(urls.map(function (s) { return addScript(s).catch(onErrorLoadingScript); }));
    }
    exports.scheduleCustomJsLoading = scheduleCustomJsLoading;
});
//# sourceMappingURL=ScriptsManager.js.map;
